import moment from "moment";

const removeLeadingZeros = (number) => {
  return number.replace(/^0+/, '')
}

const toCamelCase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const format2FAAddress = (addresses, type) => {
  const a = addresses.find((a) => a.addressType === type);
  if(a !== undefined) {
    return `${
      a.addressLine
        ? a.addressLine + ", "
        : `${a.unitNo ? a.unitNo + " " : ""}${
            a.propertyName ? a.propertyName + " " : ""
          }${a.streetNoStart ? a.streetNoStart + " " : ""}${
            a.streetName ? a.streetName + " " : ""
          }${a.streetType ? a.streetType + ", " : ""}`
    }${a.suburb ? a.suburb + ", " : ""}${a.state}, ${a.postCode}`;
  }
  else{
    return '';
  } 
};

const formatAddress = (address) => {
  if(address && address.enterManually) {
    return `${address.addressLine} ${address.suburb} ${address.state.label} ${address.postcode}`;
  } else if(address && address.lookupValue && address.lookupValue.label) {
    return address.lookupValue.label;
  } else {
    return '';
  }
}

const onlyNumbers = input => input.replace(/\D/g, '');

const onlyCharacters = input => input.replace(/[^a-zA-Z\  ]/g, '');

const onlyPhoneCharacters = input => input.replace(/[^\(\)\+0-9]+/g, '');

const setDigitsAndFocusNext = (event, numDigits, setter, next) => {
  const value = onlyNumbers(event.target.value);
  if (setter) {
    setter(value);
    if(value.length>=numDigits && next) {
      next.current.focus();
    }
  }
};

const formatMoney = (number, decPlaces, decSep, thouSep, symbol) => {
  const decPlaces2 = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
  const decSep2 = typeof decSep === "undefined" ? "." : decSep;
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces2)));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return (symbol||'') + sign +
    (j ? i.substr(0, j) + thouSep : "") +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
    (decPlaces2 ? decSep2 + Math.abs(number - i).toFixed(decPlaces2).slice(2) : "");
}

const getContactPart = (emailAddress, mobileNumber, dayTimeTelephoneNumber) => {
  return {
    emailAddress: emailAddress,
    mobileNo: mobileNumber,
    phoneNo: dayTimeTelephoneNumber,
  };
};

const getRegoNumber = (org) => {
  if (org.organisationType === 'ABN') {
    return org.abn;
  } else if (org.organisationType === 'ACN') {
    return org.acn;
  }
}

const getManualAddress = (address) => {
  if (address){
    return{
      "addressLine" : address.addressLine,
      "suburb" : address.suburb,
      "state" : address.state.value,
      "postCode" : address.postcode
    };
  }
  return null;
}

const getAddressDetail = (primaryAddress, secondaryAddress, sameAsResidentialFlag, addresses, partyType) => {
  let address = [];
 if (primaryAddress && primaryAddress.addressNotChanged === false){
  if(primaryAddress && !primaryAddress.international){
    address = address.concat ({
        "addressType": partyType === "Individual" ? "Residential": "Business",
        "enterManually": primaryAddress.enterManually,
        "manualAddress": !primaryAddress.lookupValue ? getManualAddress(primaryAddress) : {},
        "lookupValue": primaryAddress.lookupValue ? primaryAddress.lookupValue : {},
        "details": primaryAddress.details ? primaryAddress.details : {},
        "addressNotChanged" : primaryAddress.addressNotChanged
      })
  }
  else if(primaryAddress && primaryAddress.international){
    address = address.concat ({
        "addressNotChanged" : primaryAddress.addressNotChanged,
        "addressType": partyType === "Individual" ? "Residential": "Business",
        "details": {
          "Status": "Success",
          "Address" : {
            "addressLine1": primaryAddress.addressLine,
            "suburb": primaryAddress.suburb,
            "state": primaryAddress.state,
            "postcode": primaryAddress.postcode,
            "country" : primaryAddress.country
          }
        }
    })
  }
 }
 else if (primaryAddress){
  address = address.concat({
    "addressType": partyType === "Individual" ? "Residential": "Business",
    "addressNotChanged" : primaryAddress.addressNotChanged
  })
 }
 if (secondaryAddress.addressNotChanged === false){
  if (secondaryAddress && !secondaryAddress.international){
    address = address.concat ({
      "addressType": "Postal",
      "enterManually": secondaryAddress.enterManually,
      "manualAddress": !secondaryAddress.lookupValue ? getManualAddress(secondaryAddress) : {},
      "lookupValue": secondaryAddress.lookupValue ? secondaryAddress.lookupValue : {},
      "details": secondaryAddress.details ? secondaryAddress.details : {}
      })
    }
      else if (secondaryAddress && secondaryAddress.international){
        address = address.concat ({
        "addressNotChanged" : secondaryAddress.addressNotChanged,
        "addressType": "Postal",
        "details": {
          "Status": "Success",
          "Address" : {
            "addressLine1": secondaryAddress.addressLine,
            "suburb": secondaryAddress.suburb,
            "state": secondaryAddress.state,
            "postcode": secondaryAddress.postcode,
            "country" : secondaryAddress.country
          }
        }
      })
  } 
 }
 else if(sameAsResidentialFlag){
  if (secondaryAddress && !secondaryAddress.international){
    const a = addresses.find((a) => a.addressType === "Residential");
    address = address.concat ({
      "addressNotChanged" : false,
        "addressType":  "Postal",
        "details": {
          "Status": "Success",
          "Address" : {
            "addressLine1": a.addressLine,
            "suburb": a.suburb,
            "state": a.state,
            "postcode": a.postcode,
            "country" : a.country
          }
        }
        })
    }
 }
 else{
  address = address.concat({
    "addressType": "Postal",
    "addressNotChanged" : secondaryAddress.addressNotChanged
  })
 }
      
  return address;
}

const formattedFloraFaunaJsonToSubmit= (application, personalDetails, referenceDataDetail, qualificationDetail, associateDetail, organisationDetail, locationDetail,
  focusOfWork, projectDetail, documents, twoFA )=> {
    let applicantDetail = null;
    let individualList = [];
    let organisationList = [];
    let project = null;
    let qualificationList = [];
    let locationList = [];
    let focusOfWorkList = [];
    let classList = [];

    if (qualificationDetail && qualificationDetail.qualificationList) {
      qualificationList = qualificationList.concat(qualificationDetail.qualificationList.map((qal, index) => {
        return {
          "id": "qual" + index,
          "issuingAuthority": qal.issuingAuthority,
          "courseName": qal.courseName,
          "instituteName": qal.institutionName,
          "certificateName": qal.certificateName,
          "certificateDate": (moment(qal.monthOfCertificateDate + "/" + qal.dayOfCertificateDate + "/" + qal.yearOfCertificateDate).format("DD/MM/YYYY")),
          "details": qal.details
        }
      }))
    }

    if (personalDetails){
      applicantDetail = {
        "roles": [
          "Applicant"
        ],
        "id": "applicant1",
        "title": personalDetails.title.label,
        "firstName": twoFA.data ? twoFA.data.firstName : "",
        "middleName": twoFA.data ? twoFA.data.middleName : "",
        "surname": twoFA.data ? twoFA.data.lastName : "",
        "dateofbirth": twoFA.data ? (moment(twoFA.data.month + "/" + twoFA.data.day + "/" + twoFA.data.year).format("DD/MM/YYYY")) : null,
        "twoFaVerified": twoFA.twoFaVerified,
        "contactPart": getContactPart(personalDetails.emailAddress, personalDetails.mobileNumber, personalDetails.dayTimeTelephoneNumber),
        "addresses": getAddressDetail(personalDetails.address, personalDetails.secondaryAddress, personalDetails.isSameAsPrimaryAddress, twoFA.data.addressses, "Individual"),
        "qualifications" : qualificationList
      }
    }

    if (locationDetail && locationDetail.locationList) {
      locationList = locationList.concat(locationDetail.locationList.map((loc, index) => {
        return {
          "id": "associate" + index,
          "tenureType": loc.tenureType.value,
          "lga": loc.lga.value,
          "lls": loc.lls.value,
          "karstArea": loc.karstArea.value,
          "stateForest": loc.stateForest.value,
          "marinePark": loc.marinePark.value,
          "locationSearch": loc.locationSearch.value,
          "other": loc.other
        }
      }))
    }

    if (focusOfWork && focusOfWork.focusOfWorkList) {
      focusOfWorkList = focusOfWorkList.concat(focusOfWork.focusOfWorkList.map((fow, index) => {
        return {
          "id": "focusofwork" + index,
          "commonName": fow.commonName.label,
          "sampleUnit": fow.sampleUnit.value,
          "targetPart": fow.targetPart.value,
          "speciesSearch": fow.speciesSearch.label,
          "speciesRowId" : fow.speciesSearch ? fow.speciesSearch.value : fow.commonName.value,
          "targetPartNumber": fow.targetPartNumber,
          "speciesType": fow.speciesType
        }
      }))
    }

    if (referenceDataDetail && referenceDataDetail.selectedClasses) {
      classList = classList.concat(referenceDataDetail.selectedClasses.map((cls, index) => {
        return {
           "className": cls
        }
      }))
    }    
  
    if (associateDetail && associateDetail.associateList) {
      individualList = individualList.concat(associateDetail.associateList.map((ind, index) => {
        return {
          "roles": [
            "Associate"
          ],
          "id": "associate" + index,
          "title": ind.title.label,
          "firstName": ind.firstName,
          "middleName": ind.middleName,
          "surname": ind.lastName,
          "dateofbirth": (moment(ind.monthOfBirth + "/" + ind.dayOfBirth + "/" + ind.yearOfBirth).format("DD/MM/YYYY")),
          "contactPart": getContactPart(ind.email, ind.mobileNumber, ind.dayTimePhoneNumber)
        }
      }))
    }
    
    if (organisationDetail && organisationDetail.hasOrganisation === 'yes'){
      organisationList = [{
          "roles": [
            "Associated Organisation"
          ],
          "registrationType": organisationDetail.organisationType,
          "registrationNumber": getRegoNumber(organisationDetail),
          "name": organisationDetail.organisationBusinessName,
          "phoneNumber": organisationDetail.dayTimePhoneNumber,
          "emailAddress": organisationDetail.email,
          "webAddress": organisationDetail.webAddress,          
          "addresses": getAddressDetail(organisationDetail.businessAddress, organisationDetail.postalAddress, false, null, "Organisation")
        }]
      }

    if (projectDetail) {
      project = {
        "title": projectDetail.title,
        "objective": projectDetail.objective,
        "equipment": projectDetail.equipment,
        "projectEndDate": (moment(projectDetail.monthOfProjectEndDate + "/" + projectDetail.dayOfProjectEndDate + "/" + projectDetail.yearOfProjectEndDate).format("DD/MM/YYYY"))
      };
    }

  
  let formattedJSON = {
    "agencyCode": "DEC",
    "applicationId": application.applicationId,
    "licenceType": "Scientific",
    "applicationNo": application.applicationNo,
    "classList": classList,
    "applicantType": "Individual",
    "durationRequested": '0',
    "individualApplicantDetails" : applicantDetail,
   "associatedIndividuals": individualList,
   "associatedOrganisations": organisationList,
    "projectDetail": project,
    "locationDetail" : locationList,
     "focusOfWorkDetail" : focusOfWorkList,
    "attachments": [...(JSON.parse(documents.documentList))]
  }
  debugger;
  const test = JSON.stringify(formattedJSON);
  return formattedJSON;
};

const formattedIndividualJsonToSubmit= (application, importExportDetails, personalDetails, twoFA, interStateDetails, speciesDetails, licenceDetails)=> {

  // let interstateDetailRoles = 
  //     {
  //       "roles": [
  //         "Supplier"
  //       ],
  //     };

//  let organisationList = [];

  // if(importExportDetails.interStateDecisionAppType === 'Organisation')
  // {
  //   organisationList = [
  //     {
  //       "roles": [
  //         "Supplier"
  //       ],
  //       "id": "organisation1",
  //       "registrationType": interStateDetails.organisationIdType,
  //       "registrationNumber": interStateDetails.organisationIdNumber,
  //       "name": interStateDetails.organisationBusinessName,
  //       "phoneNumber": interStateDetails.daytimeTelephoneNumber,
  //       "emailAddress": interStateDetails.emailAddress,
  //       "mobileNo": interStateDetails.mobileNumber
  //     }       
  //   ];

  //   interstateDetailRoles = 
  //     {
  //       "roles": [
  //         "Contact Person"
  //       ],
  //     };

  // }

  let individualApplicationManualAddressDetail = null; 

  if(personalDetails.address.enterManually)
  {
    individualApplicationManualAddressDetail = 
      {
        "addressLine" : personalDetails.address.addressLine,
        "suburb" : personalDetails.address.suburb,
        "state": personalDetails.address.state.value,
        "postCode": personalDetails.address.postcode,
        "addressType": "Postal",
        "country": personalDetails.address.country
        // "country": personalDetails.address.international === true ? personalDetails.address.country : ""
      }
    
  }

  let individualApplicationDetailAddress = personalDetails.address.details;

  if(personalDetails.address.international)
  {
    individualApplicationDetailAddress = {
        "Address" : {
          "addressLine1" : personalDetails.address.addressLine,
          "suburb" : personalDetails.address.suburb,
          "state": personalDetails.address.state,
          "postCode": personalDetails.address.postcode,
          "addressType": 0,
          "country": personalDetails.address.country
        }
          
      }
    
  }


  let interSateDetailsManualAddressDetail = null;
  
  if(interStateDetails.address.enterManually)
  {
    interSateDetailsManualAddressDetail =       
      {
        "addressLine" : interStateDetails.address.addressLine,
        "suburb" : interStateDetails.address.suburb,
        "state":  interStateDetails.address.state.value,
        "postCode": interStateDetails.address.postcode,
        // "country": "Australia"
        "addressType": "Postal",
        // "country": interStateDetails.address.international === true ? interStateDetails.address.country : ""
        "country": interStateDetails.address.country
      }
      
  }

  let interStateDetailAddress = interStateDetails.address.details;

  if(interStateDetails.address.international)
  {

      interSateDetailsManualAddressDetail.state = interStateDetails.address.state;

      interStateDetailAddress = {
        "address" : {
          "addressLine1" : interStateDetails.address.addressLine,
          "suburb" : interStateDetails.address.suburb,
          "state": interStateDetails.address.state,
          "postCode": interStateDetails.address.postcode,
          "addressType": 0,
          "country": interStateDetails.address.country
        }
          
      }
    
  }

  let formattedJSON = {
    "agencyCode": "DEC",
    "licenceRowId" : licenceDetails.licenceInfo.licenceRowId,
    "applicationId": application.applicationId,
    "licenceType": "Import Export",
    "applicationNo": application.applicationNo,
    "applicantType": importExportDetails.appType,
    "licenceClass": importExportDetails.ieType,
    "durationRequested": '0',
    // "associatedIndividuals":
    // [
    //   {
    //     ...interstateDetailRoles,
    //     "id": "applicant1",
    //     "title": interStateDetails.title.value,
    //     "firstName": interStateDetails.givenName,
    //     "middleName": interStateDetails.middleName,
    //     "surname": interStateDetails.surname,
    //     "contactPart": {
    //       emailAddress: interStateDetails.emailAddress, 
    //       mobileNo: interStateDetails.mobileNumber, 
    //       phoneNo: interStateDetails.daytimeTelephoneNumber 
    //     },
    //     "addresses": [
    //       {
    //         "addressType": "Postal",
    //         "enterManually": interStateDetails.address.enterManually,
    //         "manualAddress": interSateDetailsManualAddressDetail,
    //         "lookupValue": {},
    //         "details": interStateDetailAddress           
    //       }
    //     ]  
    //   }
    // ],
    "individualApplicantDetails": {
      "roles": [
        "Licensee"
      ],
      "id": "applicant1",
      "firstName": twoFA.data ? twoFA.data.firstName : "",
      "middleName": "",
      "surname": twoFA.data ? twoFA.data.lastName : "",
      "dateofbirth": twoFA.data && twoFA.data.month && twoFA.data.day && twoFA.data.year
                      ? (moment(twoFA.data.month + "/" + twoFA.data.day + "/" + twoFA.data.year).format("DD/MM/YYYY")) 
                      : null,
      "placeOfBirth": null, //applicantDetails.placeOfBirth,
      "twoFaVerified": twoFA.data ? true : false,
      "hasOtherNames": false,
      "otherNames": null,
      "identificationDetails": null,
      "contactPart": {emailAddress: personalDetails.emailAddress, mobileNo: personalDetails.mobileNumber, phoneNo: personalDetails.dayTimeTelephoneNumber },
      "addresses": getAddressDetail(null, personalDetails.address, false, null, "Individual")
    },    
    //"associatedOrganisations": organisationList,
    "interStateLicenceDetails": 
    {
      "licenceNumber": speciesDetails.licenceNumber,
      "movementNumber": speciesDetails.permitMovementNumber,
      "speciesList" : speciesDetails.speciesList.map((species, index) => {
        return {
          "speciesCode" : species.speciesCode,
          "commonName" : species.speciesCommonName,
          "genus" : species.speciesGenus,
          "speciesName" : species.species,
          "subSpecies" : species.subspecies,
          "noOfFauna" : parseInt(species.speciesNoOfFauna),
          "atlasId" : species.atlasId,
          "class" : species.class,
        }
      })
    },
    "interstateIndividual" : {
      //...interstateDetailRoles,
      "id": "applicant1",
      "title": interStateDetails.title.value,
      "firstName": interStateDetails.givenName,
      "middleName": interStateDetails.middleName,
      "surname": interStateDetails.surname,
      "contactPart": {
        emailAddress: interStateDetails.emailAddress, 
        mobileNo: interStateDetails.mobileNumber, 
        phoneNo: interStateDetails.daytimeTelephoneNumber 
      },
      "addresses": [
        {
          "addressType": "Postal",
          "enterManually": interStateDetails.address.enterManually,
          "manualAddress": interSateDetailsManualAddressDetail,
          "lookupValue": {},
          "details": interStateDetailAddress          
        },
      ],
      "registrationType": interStateDetails.organisationIdType,
      "registrationNumber": interStateDetails.organisationIdNumber,  
      "name": interStateDetails.organisationBusinessName,
      "type": importExportDetails.interStateDecisionAppType
    }
  }

  return formattedJSON;
};

const formattedOrganisationJsonToSubmit= (oidc, application, importExportDetails,  organisationApplicationDetails, twoFA, interStateDetails, speciesDetails)=> {

  // const organisationApplicantDetails = {
  //   "roles": [
  //     "Licencee"
  //   ],
  //   "id": "organisation1",
  //   "registrationType": organisationApplicationDetails.organisationIdType,
  //   "registrationNumber": organisationApplicationDetails.organisationIdType === 'ABN' ? organisationApplicationDetails.abn : organisationApplicationDetails.acn ,
  //   "name": organisationApplicationDetails.organisationBusinessName,
  //   "phoneNumber": organisationApplicationDetails.dayTimeTelephoneNumber,
  //   "emailAddress": organisationApplicationDetails.emailAddress,
  //   "mobileNo": organisationApplicationDetails.mobileNumber
  // };

  // let associatedOrganisations = [
  //   {
  //     ...organisationApplicantDetails
  //   }  
  // ]

  // let interstateDetailRoles = 
  // {
  //   "roles": [
  //     "Supplier"
  //   ],
  // };

  // if (importExportDetails.interStateDecisionAppType === 'Organisation') {

  //   interstateDetailRoles = 
  //   {
  //     "roles": [
  //       "Contact Person"
  //     ],
  //   };
  // }

  let organisationApplicationManualAddressDetail = null; 

  if(organisationApplicationDetails.address.enterManually)
  {
    organisationApplicationManualAddressDetail = 
      {
        "addressLine" : organisationApplicationDetails.address.addressLine,
        "suburb" : organisationApplicationDetails.address.suburb,
        "state": organisationApplicationDetails.address.state.value,
        "postCode": organisationApplicationDetails.address.postcode,
        // "country": "Australia"
        "addressType": "Postal",
        "country": organisationApplicationDetails.address.country
        // "country": organisationApplicationDetails.address.international === true ? organisationApplicationDetails.address.country : ""
      }   
  }

  
  let organisationApplicationDetailAddress = organisationApplicationDetails.address.details;

  if(organisationApplicationDetails.address.international)
  {

    organisationApplicationManualAddressDetail.state = organisationApplicationDetails.address.state;

    organisationApplicationDetailAddress = {
        "address" : {
          "addressLine1" : organisationApplicationDetails.address.addressLine,
          "suburb" : organisationApplicationDetails.address.suburb,
          "state": organisationApplicationDetails.address.state,
          "postCode": organisationApplicationDetails.address.postcode,
          "addressType": 0,
          "country": organisationApplicationDetails.address.country
        }
          
      }
    
  }

  let interSateDetailsManualAddressDetail = null;
  
  if(interStateDetails.address.enterManually)
  {
    interSateDetailsManualAddressDetail =
      {
        "addressLine" : interStateDetails.address.addressLine,
        "suburb" : interStateDetails.address.suburb,
        "state": interStateDetails.address.state.value,
        "postCode": interStateDetails.address.postcode,
        "country": interStateDetails.address.country,
        // "country": "Australia"
        // "country": interStateDetails.address.international === true ? interStateDetails.address.country : "",
        "addressType": "Postal"
      }
      
  }

  let interStateApplicationDetailAddress = interStateDetails.address.details;

  if(interStateDetails.address.international)
  {

    interSateDetailsManualAddressDetail.state = interStateDetails.address.state;

    interStateApplicationDetailAddress = {
        "address" : {
          "addressLine1" : interStateDetails.address.addressLine,
          "suburb" : interStateDetails.address.suburb,
          "state": interStateDetails.address.state,
          "postCode": interStateDetails.address.postcode,
          "addressType": 0,
          "country": interStateDetails.address.country
        }
          
      }
    
  }
  

  // let associatedIndividuals = [
  //   {
  //     "roles": [
  //       "Contact Person"
  //     ],
  //     "id": "applicant1",
  //     "title": organisationApplicationDetails.title.value,
  //     "firstName": organisationApplicationDetails.firstname,
  //     "middleName": organisationApplicationDetails.middlename,
  //     "surname": organisationApplicationDetails.lastname,
  //     "contactPart": {
  //       emailAddress: organisationApplicationDetails.emailAddress, 
  //       mobileNo: organisationApplicationDetails.mobileNumber, 
  //       phoneNo: organisationApplicationDetails.daytimeTelephoneNumber 
  //     },
  //     "addresses": [
  //       {
  //         "addressType": "Postal",
  //         "enterManually": organisationApplicationDetails.address.enterManually,
  //         "manualAddress": organisationApplicationManualAddressDetail,
  //         "lookupValue": {},
  //         "details": organisationApplicationDetailAddress
  //       }
  //     ]  
  //   },    
  //   {
  //     ...interstateDetailRoles,
  //     "id": "applicant2",
  //     "title": interStateDetails.title.value,
  //     "firstName": interStateDetails.givenName,
  //     "middleName": interStateDetails.middleName,
  //     "surname": interStateDetails.surname,
  //     "contactPart": {
  //       emailAddress: interStateDetails.emailAddress, 
  //       mobileNo: interStateDetails.mobileNumber, 
  //       phoneNo: interStateDetails.daytimeTelephoneNumber 
  //     },
  //     "addresses": [
  //       {
  //         "addressType": "Postal",
  //         "enterManually": interStateDetails.address.enterManually,
  //         "manualAddress": interSateDetailsManualAddressDetail,
  //         "lookupValue": {},
  //         "details": interStateApplicationDetailAddress
  //       }
  //     ]  
  //   }
  // ];



  let formattedJSON = {
    "agencyCode": "DEC",
    // "licenceRowId" : licenceDetails.licenceInfo.licenceRowId,
    "applicationId": application.applicationId,
    "licenceType": "Import Export",
    "applicationNo": application.applicationNo,
    "applicantType": importExportDetails.appType,
    "licenceClass": importExportDetails.ieType,
    "durationRequested": '0',
    //"associatedOrganisations": associatedOrganisations, //licensee
    //"associatedIndividuals": associatedIndividuals, // contact person
    "interStateLicenceDetails": 
    {
      "licenceNumber": speciesDetails.licenceNumber,
      "movementNumber": speciesDetails.permitMovementNumber,
      "speciesList" : speciesDetails.speciesList.map((species, index) => {
        return {
          "atlasId" : species.atlasId,
          "speciesCode" : species.speciesCode,
          "commonName" : species.speciesCommonName,
          "genus" : species.speciesGenus,
          "speciesName" : species.species,
          "subSpecies" : species.subspecies,
          "noOfFauna" : parseInt(species.speciesNoOfFauna),
          "atlasId" : species.atlasId,
          "class" : species.class,
        }
      })
    },
    "organisationApplicantWithContactDetails" : { //applicant
      // "roles": [
      //   "Applicant"
      // ],
      "id": "applicant1",
      "title": organisationApplicationDetails.title.value,
      "firstName": organisationApplicationDetails.firstname,
      "middleName": organisationApplicationDetails.middlename,
      "surname": organisationApplicationDetails.lastname,
      "contactPart": {
        emailAddress: organisationApplicationDetails.emailAddress, 
        mobileNo: organisationApplicationDetails.mobileNumber, 
        phoneNo: organisationApplicationDetails.dayTimeTelephoneNumber 
      },
      "addresses": [
        {
          "addressType": "Postal",
          "enterManually": organisationApplicationDetails.address.enterManually,
          "manualAddress": organisationApplicationManualAddressDetail,
          "lookupValue": {},
          "details": organisationApplicationDetailAddress
        }
      ],
      "registrationType": organisationApplicationDetails.organisationIdType,
      "registrationNumber": organisationApplicationDetails.organisationIdType === 'ABN' ? organisationApplicationDetails.abn : organisationApplicationDetails.acn,
      "name": organisationApplicationDetails.organisationBusinessName
    },
    "interStateIndividual" : {
     // ...interstateDetailRoles,
      "id": "applicant2",
      "title": interStateDetails.title.value,
      "firstName": interStateDetails.givenName,
      "middleName": interStateDetails.middleName,
      "surname": interStateDetails.surname,
      "contactPart": {
        emailAddress: interStateDetails.emailAddress, 
        mobileNo: interStateDetails.mobileNumber, 
        phoneNo: interStateDetails.daytimeTelephoneNumber 
      },
      "addresses": [
        {
          "addressType": "Postal",
          "enterManually": interStateDetails.address.enterManually,
          "manualAddress": interSateDetailsManualAddressDetail,
          "lookupValue": {},
          "details": interStateApplicationDetailAddress
        }
      ],
      "registrationType": interStateDetails.organisationIdType,
      "registrationNumber": interStateDetails.organisationIdNumber,  
      "name": interStateDetails.organisationBusinessName,
      "type": importExportDetails.interStateDecisionAppType
    },     
  }
  return formattedJSON;
};

export {
  removeLeadingZeros,
  toCamelCase,
  format2FAAddress,
  formatAddress,
  onlyNumbers,
  onlyCharacters,
  onlyPhoneCharacters,
  setDigitsAndFocusNext,
  formatMoney,
  formattedIndividualJsonToSubmit,
  formattedOrganisationJsonToSubmit,
  formattedFloraFaunaJsonToSubmit
};